module.exports = __webpack_public_path__ + "img/124.6be6d6ea.jpg";